<!--
 * @Description:云途线索客户地图修改
 * @Author: cxh
 * @Date: 2022-06-20 13:38:14
 * @LastEditTime: 2023-06-20 15:38:33
 * @LastEditors: cxh
-->
<template>
  <cos-modal
    v-model:visible="visible"
    :loading="loading"
    title="签到地址"
    width="90%"
    height="80%"
    @ok="handleOk"
    :maskClosable="false"
  >
    <a-form :model="form" ref="formRef">
      <dc-form-item
        label="客户名称"
        :span="24"
        :rules="{
          message: '请输入',
          required: true
        }"
      >
        <CosInput v-model:value="form.addressRefName" placeholder="请输入" :disabled="true" />
      </dc-form-item>
      <dc-layout-card :span="10">
        <template #title>
          <div style="display: flex; align-items: center; height: 24px; margin-bottom: 13px">
            <div class="dc-card-header-defaut-line"></div>
            <p style="font-size: 16px; font-weight: 500">地址详情</p>
            <div style="flex: 1 1 0%; text-align: right">
              <a-button type="primary" ghost @click="handleAddressAdd(form.attrList)" v-if="!disabled">新增</a-button>
            </div>
          </div>
        </template>
        <MultipleItem :view="view" :line="false">
          <template v-for="(item, index) in form.attrList" :key="index">
            <dc-form-item
              :label="index ? '' : '签到地址'"
              :class="index ? 'no-form-label' : ''"
              :name="['attrList', index, 'addressName']"
              :span="8"
              :rules="[
            { validator: (rule:any, value:number) => checkAddressValidate(rule, value, form.attrList, 'addressTag', '请选择') }
          ]"
            >
              <MapModal v-model:address="item.addressName" v-model:geoPoint="item.geoPoint"></MapModal>
            </dc-form-item>
            <dc-form-item
            :label="index ? '' : '补充地址'"
            :class="index ? 'no-form-label' : ''"
            :name="['attrList', index, 'suppAddress']"
          >
            <CosInput v-model:value="item.suppAddress"></CosInput>
          </dc-form-item>
            <dc-form-item
              :label="index ? '' : '地址类型'"
              :class="index ? 'no-form-label' : ''"
              :span="6"
              :name="['attrList', index, 'addressTag']"
              :rules="[
            { validator: (rule:any, value:number) => checkAddressValidate(rule, value, form.attrList, 'addressName', '请选择') }
          ]"
            >
              <div class="flex">
                <ParamCodesSelect
                  :options="paramCodeData.lbu_sign_in_address_label"
                  v-model:value="item.addressTag"
                  allowClear
                />
                <a-button
                  type="text"
                  danger
                  style="padding: 0 0 0 12px"
                  v-if="form.attrList && form.attrList.length > 1"
                  @click="handleAddressAddDel(index, form.attrList)"
                  >删除</a-button
                >
                <a-checkbox style="padding: 3px 0 0 12px; width: 150px;" :checked="item.mainAddressFlag === 1" @change="clearMainAddressFlag(index)">主要</a-checkbox>
              </div>
            </dc-form-item>
          </template>
        </MultipleItem>
      </dc-layout-card>
    </a-form>
  </cos-modal>
</template>
<script lang="ts">
import { ref, onMounted } from 'vue'
import {
  checkAddressValidate,
  checkAddressData,
  handleAddressAdd,
  handleAddressAddDel,
  clear
} from '@/hooks/addressArrValidate'
import { paramCodesDataFilter } from '@/utils/index'
import { listByParamCodes } from '@/api/common'
import { queryMapList, mapListSave } from '@/api/yuntuSales/customerCenter'
import MapModal from '@/components/MapModal/index.vue'
import MultipleItem from '@/components/CosViewContent/multipleItem.vue'
import { DcMessage } from '@dc-platform/dc-components'
import { cloneDeep } from 'lodash-es'
export default { name: 'DetailCard' }
</script>
<script setup lang="ts">
interface MapItem {
  addressName: string
  addressTag?: number
  geoPoint: {
    latitude: number
    longitude: number
  }
  id?: number
}
interface CustomerMapItem {
  addressRefId: string
  addressRefName: string
  attrList: MapItem[]
}
const paramCodeData = ref<any>({
  lbu_sign_in_address_label: []
})
const formRef = ref()
const form = ref<any>({
  attrList: []
})
const loading = ref<boolean>(false)
const visible = ref<boolean>(false)
// 获取业务参数
const getByParamCodes = () => {
  listByParamCodes({
    appId: 'cos_lbu',
    paramCodes: ['lbu_sign_in_address_label']
  }).then((res) => {
    if (res.code === 200) {
      paramCodeData.value = paramCodesDataFilter(res.data, 0)
    }
  })
}

const clearMainAddressFlag = (index: number) => {
  if (form.value.attrList) {
    for (const [i, item] of form.value.attrList.entries()) {
      if (index === i) {
        item.mainAddressFlag = item.mainAddressFlag === 1 ? 0 : 1
      } else {
        item.mainAddressFlag = 0
      }
    }
  }
}
// 查询客户地图详情
const fetch = (row: { addressRefId: string; addressRefName: string }) => {
  const { addressRefId, addressRefName } = row
  queryMapList({ addressRefId }).then((res) => {
    form.value = {
      addressRefId,
      addressRefName: addressRefName || '--',
      attrList: res.data && res.data.length ? res.data : [{}]
    }
  })
}
// 提交客户地图
const handleOk = () => {
  formRef.value?.validate().then((res: any) => {
    const p = cloneDeep(form.value)
    if (checkAddressData(form.value.attrList)) {
      DcMessage.error('签到地址不可重复！')
      return false
    }
    const { attrList } = p
    p.attrList = attrList.filter((item: MapItem) => item.addressName)
    loading.value = true
    mapListSave(p)
      .then((res) => {
        DcMessage.success('设置成功')
        visible.value = false
      })
      .finally(() => {
        loading.value = false
      })
  })
}
onMounted(() => {
  getByParamCodes()
})
const toggle = (row: CustomerMapItem) => {
  visible.value = !visible.value
  if (row.addressRefId) {
    fetch(row)
  }
}
defineExpose({
  toggle
})
</script>
